(() => {
  function replaceTag(el, newTagName) {
    if (!el || !el.parentNode) return;

    const replacement = document.createElement(newTagName);

    for (const attr of Array.from(el.attributes)) {
      replacement.setAttribute(attr.name, attr.value);
    }

    replacement.innerHTML = el.innerHTML;
    el.parentNode.replaceChild(replacement, el);
  }

  function cleanCartDrawerHeadings(root = document) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('cart-drawer h2.cart__empty-text').forEach((el) => replaceTag(el, 'p'));
    scope.querySelectorAll('cart-drawer h2.drawer__heading').forEach((el) => replaceTag(el, 'div'));
    scope.querySelectorAll('cart-drawer h2.totals__total').forEach((el) => replaceTag(el, 'p'));
  }

  function cleanDuplicateCardHeadings(root = document) {
    const scope = root && root.querySelectorAll ? root : document;

    // Dawn outputs a first product/collection heading inside .card__inner, then a second visible card heading below.
    // The first one is useful for the card overlay logic, but it pollutes the document outline with duplicate H3s.
    scope.querySelectorAll('.card__inner h3.card__heading').forEach((el) => replaceTag(el, 'div'));

    // Quick-add modals are interface elements, not editorial page headings.
    scope.querySelectorAll('quick-add-modal h3, modal-dialog.quick-add-modal h3').forEach((el) => replaceTag(el, 'div'));
  }

  function cleanEmptyHeadings(root = document) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('h1, h2, h3').forEach((el) => {
      const text = (el.textContent || '').trim();
      const hasMeaningfulImageAlt = Array.from(el.querySelectorAll('img')).some((img) => (img.getAttribute('alt') || '').trim() !== '');

      if (text === '' && !hasMeaningfulImageAlt) {
        replaceTag(el, 'div');
      }
    });
  }

  function cleanUtilityHeadings(root = document) {
    const scope = root && root.querySelectorAll ? root : document;

    // Facets/sort counters are UI labels. They should not become SEO/document headings.
    scope.querySelectorAll('h2.facet-filters__label, h2.product-count__text').forEach((el) => replaceTag(el, 'div'));
  }

  function run(root = document) {
    cleanCartDrawerHeadings(root);
    cleanDuplicateCardHeadings(root);
    cleanUtilityHeadings(root);
    cleanEmptyHeadings(root);
  }

  function boot() {
    run();
    setTimeout(run, 250);
    setTimeout(run, 800);
    setTimeout(run, 1600);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) run(node);
        });
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
